module.exports = __webpack_public_path__ + "static/media/IMG_5627.d4da9099.jpg";